import type { SendReadinessAction } from "../../../../../core/src/review/send-readiness-types";
import type { SolFactDisagreement } from "../../../../../core/src/workflow/sol-fact-authority-types";

/** The checklist and details dialog name the same server action identically. `done`: the one-click
 * step that settles a point of an offer (#2516); the checklist offers only that step. */
export function taskActionLabel(kind: string | undefined, action: SendReadinessAction, done = false): string {
  if (kind === "fact_disagreement" && action === "reply_confirmed") return "sendReady.disagreement.confirm";
  if (kind === "outside_hamburg" && (action === "approved" || action === "refused")) return `sendReady.delivery.${action}`;
  if (done && action === "approved") return "sendReady.action.done";
  return `sendReady.action.${action}`;
}

/** Keep distinct source locations; only repeated references to the same quote collapse. */
export function distinctDisagreementEvidence(evidence: SolFactDisagreement["evidence"]) {
  const seen = new Set<string>();
  return evidence.filter(e => {
    const key = JSON.stringify([e.message_id, e.source, e.source_hash, e.start, e.text]);
    if (seen.has(key)) return false;
    seen.add(key); return true;
  });
}
